// extracted by mini-css-extract-plugin
export default {"section-content-heading":"HoablInvestedUser_section-content-heading__igBX+","divider":"HoablInvestedUser_divider__uLSW7"};